import { Component, Inject } from '@angular/core';
import { ProtocolDefinitions } from '../../../model/protocol';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../services/snackBar.service';
import { ThemeService } from '../../../services/theme.service';
import { ArrayUtils } from '../../../utils/arrayUtils';

export interface DialogDataDefinitions{
  definition: ProtocolDefinitions;
  isEdit: boolean;
  disabled: boolean;
}

@Component({
  selector: 'app-edit-definitions',
  templateUrl: './edit-definitions.component.html',
  styleUrls: ['./edit-definitions.component.scss'],
  standalone: false
})
export class EditDefinitionsComponent {

   constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogDataDefinitions,
    public dialogRef: MatDialogRef<EditDefinitionsComponent>,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    private themeService: ThemeService) { }

  onOkClick(): void {
    const errors = [];

    const item = this.data.definition;

    if (item.term == null) {
      errors.push(this.translate.instant('protocolEdit.definitions.form.error.term'));
    }

     if (item.definition == null) {
      errors.push(this.translate.instant('protocolEdit.definitions.form.error.definition'));
    }

    if (ArrayUtils.isEmpty(errors)) {
      this.dialogRef.close(item);
    } else {
      const error = errors.join('\n');
      this.snackBarService.sendError(error);
      console.error(error);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }
}
